module.exports = __webpack_public_path__ + "static/geerntet-04-d0947fbfaddb0569870a674b899e4510.jpg";